import styled from '@emotion/styled'

const StyledDiv = styled.div`
  max-width: ${(props) => props.theme.widths[0]};
  margin: 0 auto;
  line-height: 1.67;
  p {
    font-size: 1rem;
    color: ${(props) => props.theme.colors.lightGray};
    margin: ${(props) =>
      props.type === 'sankey'
        ? 0
        : props.type === 'tech'
          ? '2rem 0 0 .75rem'
          : '2rem 0 0'};
  }
`

const Note = ({ note, type }) => {
  return <StyledDiv type={type} dangerouslySetInnerHTML={{ __html: note }} />
}

export default Note
